const getApiHost = (env) => {
  if (env === 'dev') {
    return 'https://api.storytelbridge.com/web-runtime-api';
  }
  return `${window.location.origin}/wra`;
};

const getFeatureFlagUrl = (env, isoCountry) => {
  const hostname = typeof window !== 'undefined' && window.location.host;
  let apiHost = '';
  const protocol = typeof window !== 'undefined' ? window.location.protocol : 'http:';

  if (env !== 'prod' && /^localhost:(\d+)$/.test(hostname)) {
    // localhost development
    apiHost = 'localhost:3000';
  } else if (env !== 'prod' && /^test\d+\.storytel\.(com|dev)$/.test(hostname)) {
    // test environments test01..10
    apiHost = hostname;
  } else if (/^(.+?\.)?storytel\.(com|dev)$/.test(hostname)) {
    // most likely production domains
    const tld = hostname.indexOf('storytel.com') > -1 ? '.com' : '.dev';
    apiHost = 'account.storytel' + tld;
  } else if (hostname.indexOf('mofibo.com') > -1) {
    // mofibo.com production domain
    apiHost = 'myaccount.mofibo.com';
  }

  return `${protocol}//${apiHost}/api/my-account/feature-flags/${isoCountry}`;
};

/**
 * For local development purpose only
 * Returns a header with the user's token found in 'SSO_Token' cookie
 */
const getHeaders = (env) => {
  const headers = new Headers();
  if (env === 'dev') {
    const token = (
      document.cookie.split('; ').find((row) => row.startsWith('SSO_Token=')) || ''
    ).split('=')[1];

    headers.set('X-Storytel-SSO-Token', token || '');
  }

  return headers;
};

module.exports = { getApiHost, getHeaders, getFeatureFlagUrl };
